/* SmartBowl — interacciones (mt-) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals con escalonado ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    document.querySelectorAll('[data-mt-stagger]').forEach(function (grupo) {
      var paso = parseFloat(grupo.getAttribute('data-mt-stagger')) || 0.08;
      grupo.querySelectorAll('.mt-reveal').forEach(function (el, i) {
        el.style.setProperty('--mt-delay', (i * paso) + 's');
      });
    });
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          if (e.target.hasAttribute('data-mt-contar')) contar(e.target);
          e.target.querySelectorAll('[data-mt-contar]').forEach(contar);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras que cuentan ---------- */
  function contar(el) {
    if (el.dataset.mtContado) return;
    el.dataset.mtContado = '1';
    var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
    if (reducido) { el.textContent = fin; return; }
    var dur = 1600, inicio = null;
    function frame(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(fin * e);
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Añadir al carrito (abre el carrito lateral de Dawn) ---------- */
  function initCarrito() {
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form.matches || !form.matches('form[data-mt-carrito]')) return;
      if (!window.fetch) return;
      ev.preventDefault();
      var boton = form.querySelector('[type="submit"]');
      var textoOriginal = boton ? boton.innerHTML : '';
      if (boton) { boton.disabled = true; boton.innerHTML = boton.getAttribute('data-mt-cargando') || '…'; }
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var datos = new FormData(form);
      if (drawer && drawer.getSectionsToRender) {
        datos.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        datos.append('sections_url', window.location.pathname);
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: datos
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { throw new Error(res.description || res.message); }
          if (drawer && drawer.renderContents) {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          var estado = form.closest('[data-mt-compra]') && form.closest('[data-mt-compra]').querySelector('.mt-compra__estado');
          if (estado) { estado.style.color = '#C2261C'; estado.textContent = err.message || 'Something went wrong. Please try again.'; }
        })
        .finally(function () {
          if (boton) { boton.disabled = false; boton.innerHTML = textoOriginal; }
        });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    var raiz = document.querySelector('[data-mt-compra]');
    if (!raiz) return;

    // Galería
    var principal = document.querySelector('[data-mt-principal]');
    document.querySelectorAll('[data-mt-mini]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!principal) return;
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = b.getAttribute('data-mt-mini');
          principal.srcset = b.getAttribute('data-mt-srcset') || '';
          principal.alt = b.getAttribute('data-mt-alt') || '';
          principal.style.opacity = 1;
        }, 160);
        document.querySelectorAll('[data-mt-mini]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    // Cantidad
    var cantidad = raiz.querySelector('[data-mt-cantidad]');
    raiz.querySelectorAll('[data-mt-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cantidad) return;
        var v = parseInt(cantidad.value, 10) || 1;
        v += parseInt(b.getAttribute('data-mt-cant'), 10);
        cantidad.value = Math.max(1, v);
      });
    });

    // Variantes
    var json = document.querySelector('[data-mt-variantes]');
    if (json) {
      var variantes = JSON.parse(json.textContent);
      var moneda = raiz.getAttribute('data-mt-moneda') || '';
      raiz.addEventListener('change', function (ev) {
        if (!ev.target.matches('[data-mt-opcion]')) return;
        var elegidas = [];
        raiz.querySelectorAll('fieldset[data-mt-fieldset]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        actualizarVariante(v, moneda);
      });
    }

    // Barra fija en móvil
    var barra = document.querySelector('.mt-barra-fija');
    var botonPrincipal = raiz.querySelector('[data-mt-boton-principal]');
    if (barra && botonPrincipal && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        barra.classList.toggle('mt-visible-barra', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(botonPrincipal);
    }
  }

  function dinero(centimos, moneda) {
    try {
      var idioma = moneda === 'USD' ? 'en-US' : (document.documentElement.lang || 'en-US');
      return new Intl.NumberFormat(idioma, { style: 'currency', currency: moneda }).format(centimos / 100);
    } catch (e) { return (centimos / 100).toFixed(2); }
  }

  function actualizarVariante(v, moneda) {
    var ids = document.querySelectorAll('[data-mt-variante-id]');
    var botones = document.querySelectorAll('[data-mt-boton-comprar]');
    if (!v) {
      botones.forEach(function (b) { b.disabled = true; b.textContent = b.getAttribute('data-mt-no-disponible'); });
      return;
    }
    ids.forEach(function (i) { i.value = v.id; });
    document.querySelectorAll('[data-mt-precio]').forEach(function (p) { p.textContent = dinero(v.price, moneda); });
    document.querySelectorAll('[data-mt-antes]').forEach(function (p) {
      if (v.compare_at_price && v.compare_at_price > v.price) { p.hidden = false; p.textContent = dinero(v.compare_at_price, moneda); }
      else { p.hidden = true; }
    });
    botones.forEach(function (b) {
      b.disabled = !v.available;
      b.innerHTML = v.available ? b.getAttribute('data-mt-texto') : b.getAttribute('data-mt-agotado');
    });
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* ---------- Compra rápida de la portada ---------- */
  function initRapida() {
    var raiz = document.querySelector('[data-mt-rapida]');
    if (!raiz || raiz.dataset.mtListo) return;
    raiz.dataset.mtListo = '1';
    var datosEl = raiz.querySelector('[data-mt-rapida-datos]');
    if (!datosEl) return;
    var datos;
    try { datos = JSON.parse(datosEl.textContent); } catch (e) { return; }
    var moneda = raiz.getAttribute('data-mt-moneda') || 'USD';
    var activo = raiz.querySelector('[data-mt-rapida-color].is-activo');
    var estado = { i: parseInt(raiz.getAttribute('data-mt-inicial'), 10) || 0, color: activo ? activo.getAttribute('data-mt-rapida-color') : null };

    function varianteDe(prod) {
      if (!prod || !prod.variantes.length) return null;
      return prod.variantes.find(function (v) { return v.opcion === estado.color; }) || prod.variantes[0];
    }

    var principal = raiz.querySelector('[data-mt-rapida-principal]');
    var video = raiz.querySelector('[data-mt-rapida-video]');

    function minisActuales() {
      var g = raiz.querySelector('[data-mt-rapida-minis="' + estado.i + '"]');
      return g ? Array.prototype.slice.call(g.querySelectorAll('[data-mt-rapida-mini]')) : [];
    }

    function mostrarFoto(src, srcVideo) {
      if (video) {
        if (srcVideo) {
          video.src = srcVideo; video.hidden = false;
          if (principal) principal.style.visibility = 'hidden';
          var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
          return;
        }
        video.pause(); video.hidden = true; video.removeAttribute('src');
      }
      if (!principal) return;
      principal.style.visibility = '';
      if (principal.getAttribute('src') === src) return;
      principal.removeAttribute('srcset');
      principal.style.opacity = 0;
      var tmp = new Image();
      tmp.onload = tmp.onerror = function () { principal.src = src; principal.style.opacity = 1; };
      tmp.src = src;
    }

    function mostrarMini(m) {
      raiz.querySelectorAll('[data-mt-rapida-mini]').forEach(function (x) { x.classList.toggle('is-activa', x === m); });
      mostrarFoto(m.getAttribute('data-mt-src'), m.getAttribute('data-mt-video'));
    }

    function pintar(cambiarFoto) {
      datos.forEach(function (prod, idx) {
        var v = varianteDe(prod);
        if (!v) return;
        var p = raiz.querySelector('[data-mt-rapida-precio="' + idx + '"]');
        if (p) p.textContent = dinero(v.precio, moneda);
        var a = raiz.querySelector('[data-mt-rapida-antes="' + idx + '"]');
        if (a) { a.hidden = !(v.antes > v.precio); a.textContent = dinero(v.antes, moneda); }
        var pm = raiz.querySelector('[data-mt-rapida-pormascota="' + idx + '"]');
        if (pm) pm.textContent = dinero(Math.floor(v.precio / (prod.mascotas || 1)), moneda);
      });
      raiz.querySelectorAll('[data-mt-rapida-opcion]').forEach(function (b) {
        var on = parseInt(b.getAttribute('data-mt-rapida-opcion'), 10) === estado.i;
        b.classList.toggle('is-activa', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      raiz.querySelectorAll('[data-mt-rapida-color]').forEach(function (b) {
        b.classList.toggle('is-activo', b.getAttribute('data-mt-rapida-color') === estado.color);
      });
      var nombre = raiz.querySelector('[data-mt-rapida-color-nombre]');
      if (nombre && estado.color) nombre.textContent = estado.color;

      var prod = datos[estado.i];
      var v = varianteDe(prod);
      if (!v) return;
      raiz.querySelector('[data-mt-rapida-id]').value = v.id;
      raiz.querySelectorAll('[data-mt-rapida-minis]').forEach(function (g) {
        g.hidden = parseInt(g.getAttribute('data-mt-rapida-minis'), 10) !== estado.i;
      });
      if (cambiarFoto) {
        var minis = minisActuales();
        var objetivo = minis.find(function (m) { return parseInt(m.getAttribute('data-mt-media-id'), 10) === v.media; }) || minis[0];
        if (objetivo) mostrarMini(objetivo);
        else if (v.img) mostrarFoto(v.img, null);
      }
      var precioTxt = dinero(v.precio, moneda);
      var bp = raiz.querySelector('[data-mt-rapida-boton-precio]');
      if (bp) bp.textContent = precioTxt;
      var barra = raiz.querySelector('[data-mt-rapida-barra-precio]');
      if (barra) barra.textContent = precioTxt;
      var boton = raiz.querySelector('[data-mt-rapida-boton]');
      if (boton) {
        boton.disabled = !v.disponible;
        if (!v.disponible) boton.textContent = boton.getAttribute('data-mt-agotado');
        else if (!bp) boton.innerHTML = boton.getAttribute('data-mt-texto') + ' · <span data-mt-rapida-boton-precio>' + precioTxt + '</span>';
      }
      var det = raiz.querySelector('[data-mt-rapida-detalles]');
      if (det && prod.url) det.href = prod.url + '?variant=' + v.id;
    }

    raiz.addEventListener('click', function (ev) {
      var op = ev.target.closest('[data-mt-rapida-opcion]');
      if (op) { estado.i = parseInt(op.getAttribute('data-mt-rapida-opcion'), 10); pintar(true); return; }
      var col = ev.target.closest('[data-mt-rapida-color]');
      if (col) { estado.color = col.getAttribute('data-mt-rapida-color'); pintar(true); return; }
      var mini = ev.target.closest('[data-mt-rapida-mini]');
      if (mini) { mostrarMini(mini); return; }
      var mover = ev.target.closest('[data-mt-rapida-mover]');
      if (mover) {
        var lista = minisActuales();
        if (!lista.length) return;
        var actual = lista.findIndex(function (x) { return x.classList.contains('is-activa'); });
        var sig = (actual + parseInt(mover.getAttribute('data-mt-rapida-mover'), 10) + lista.length) % lista.length;
        mostrarMini(lista[sig]);
        lista[sig].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        return;
      }
      var copiar = ev.target.closest('[data-mt-copiar]');
      if (copiar) {
        var codigo = copiar.getAttribute('data-mt-copiar');
        var hecho = function () { var t = copiar.innerHTML; copiar.textContent = copiar.getAttribute('data-mt-copiado') || '✓'; setTimeout(function () { copiar.innerHTML = t; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(codigo).then(hecho, hecho); else hecho();
        return;
      }
      var ya = ev.target.closest('[data-mt-rapida-ya]');
      if (ya) {
        var form = raiz.querySelector('[data-mt-rapida-form]');
        ya.disabled = true;
        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }] })
        }).then(function () { window.location.href = '/checkout'; })
          .catch(function () { ya.disabled = false; });
      }
    });

    var botonPrincipal = raiz.querySelector('[data-mt-rapida-boton]');
    var barraFija = raiz.querySelector('.mt-barra-fija');
    if (barraFija && botonPrincipal && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        barraFija.classList.toggle('mt-visible-barra', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(botonPrincipal);
    }
    pintar();
  }

  /* ---------- "Para quién es": elegir producto en la compra rápida ---------- */
  function initElegir() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('[data-mt-elegir]');
      if (!a) return;
      var opcion = document.querySelector('[data-mt-rapida-opcion][data-mt-handle="' + a.getAttribute('data-mt-elegir') + '"]');
      if (!opcion) return;
      ev.preventDefault();
      opcion.click();
      var destino = document.querySelector('[data-mt-rapida]');
      if (destino) destino.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Reseñas: leer más / menos ---------- */
  function initResenas() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-mt-leer]');
      if (!b) return;
      var texto = b.previousElementSibling;
      if (!texto) return;
      var abierto = texto.classList.toggle('is-abierto');
      b.textContent = abierto ? b.getAttribute('data-mt-menos') : b.getAttribute('data-mt-mas');
    });
  }

  /* ---------- Pop-up de email con descuento ---------- */
  function initPopup() {
    var p = document.querySelector('[data-mt-popup]');
    if (!p || p.dataset.mtListo) return;
    p.dataset.mtListo = '1';
    if (window.Shopify && window.Shopify.designMode) return;
    var visto = null, suscrito = null;
    try { visto = localStorage.getItem('mt_popup_visto'); suscrito = localStorage.getItem('mt_popup_suscrito'); } catch (e) {}
    if (document.cookie.indexOf('mt_popup_visto=1') > -1) visto = '1';
    if (suscrito || visto) return;

    var inicio = Date.now();
    var form = p.querySelector('[data-mt-popup-form]');
    var panelForm = p.querySelector('[data-mt-popup-formulario]');
    var panelExito = p.querySelector('[data-mt-popup-exito]');
    var error = p.querySelector('[data-mt-popup-error]');
    var temporizador = null;
    var mostrado = false;

    function abrir() {
      if (mostrado || p.classList.contains('is-abierto')) return;
      mostrado = true;
      clearTimeout(temporizador);
      try { document.cookie = 'mt_popup_visto=1; max-age=31536000; path=/; SameSite=Lax'; } catch (e) {}
      p.hidden = false;
      setTimeout(function () { p.classList.add('is-abierto'); }, 30);
      try { localStorage.setItem('mt_popup_visto', String(Date.now())); } catch (e) {}
      var campo = p.querySelector('input[type="email"]');
      if (campo) setTimeout(function () { try { campo.focus({ preventScroll: true }); } catch (e) {} }, 400);
    }
    function cerrar() {
      p.classList.remove('is-abierto');
      setTimeout(function () { p.hidden = true; }, 300);
    }

    temporizador = setTimeout(abrir, (parseInt(p.getAttribute('data-mt-retraso'), 10) || 20) * 1000);
    document.addEventListener('mouseout', function (ev) {
      if (!ev.relatedTarget && ev.clientY <= 0 && Date.now() - inicio > 8000) abrir();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && p.classList.contains('is-abierto')) cerrar(); });
    p.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-mt-popup-cerrar]')) { cerrar(); return; }
      var c = ev.target.closest('[data-mt-popup-copiar]');
      if (c) {
        var codigo = c.getAttribute('data-mt-popup-copiar');
        var hecho = function () { var t = c.innerHTML; c.textContent = c.getAttribute('data-mt-copiado') || '✓'; setTimeout(function () { c.innerHTML = t; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(codigo).then(hecho, hecho); else hecho();
      }
    });

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var boton = form.querySelector('[type="submit"]');
        if (boton) boton.disabled = true;
        if (error) error.hidden = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' }, redirect: 'follow' })
          .then(function (r) {
            if (/customer_posted=true/.test(r.url)) {
              try { localStorage.setItem('mt_popup_suscrito', '1'); } catch (e) {}
              panelForm.hidden = true;
              panelExito.hidden = false;
            } else if (/challenge/.test(r.url)) {
              window.location.href = r.url;
            } else {
              throw new Error('no ok');
            }
          })
          .catch(function () { if (error) error.hidden = false; })
          .finally(function () { if (boton) boton.disabled = false; });
      });
    }
  }

  function init() {
    document.documentElement.classList.remove('mt-no-js');
    initPopup();
    initResenas();
    initElegir();
    initReveals();
    initCarrito();
    initProducto();
    initRapida();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de Shopify: reactivar al recargar secciones
  document.addEventListener('shopify:section:load', function () { initReveals(); initRapida(); initPopup(); });
})();
